import type { ButtonHTMLAttributes, ReactNode } from "react";
import { brandColors as colors, usePalette } from "@/lib/palette";
import { fonts } from "@/lib/fonts";

type ButtonVariant = "primary" | "secondary" | "ghost";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  icon?: ReactNode;
};

export default function Button({
  variant = "primary",
  icon,
  className = "",
  children,
  style,
  ...props
}: ButtonProps) {
  const theme = usePalette();
  const palette =
    variant === "primary"
      ? { backgroundColor: theme.accent, color: "white", borderColor: theme.accent }
      : variant === "secondary"
        ? { backgroundColor: colors.cream, color: colors.navy, borderColor: `${colors.tan}55` }
        : { backgroundColor: "transparent", color: theme.accent, borderColor: "transparent" };

  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-full border px-5 py-2.5 text-sm transition-all duration-200 hover:shadow-lg active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-55 ${className}`}
      style={{
        ...palette,
        fontFamily: fonts.button,
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        ...style,
      }}
      {...props}
    >
      {icon}
      {children}
    </button>
  );
}
